@if (!isLoading) {
    @if (standalone) {
        <app-header/>
        <ion-content>
            <ng-container *ngTemplateOutlet="logMessageDetails"></ng-container>
        </ion-content>
    } @else {
        <div>
            <ng-container *ngTemplateOutlet="logMessageDetails"></ng-container>
        </div>
    }

    <ng-template #logMessageDetails>
        <app-error-detail-template [error]="error!" (errorTypeUpdated)="updateErrorType($event)"
                                   [solveError]="solveError">
            <app-error-detail-rule ruleNameKey="components.errorDetails.errorCardDetails.ruleName.description"
                                   [content]="error!.description"/>
            <app-error-detail-rule ruleNameKey="components.errorDetails.errorCardDetails.ruleName.content"
                                   [content]="error!.content"/>
        </app-error-detail-template>
    </ng-template>
}
